export const BADGE_MAX_VALUE = 999
